import React, { useMemo } from 'react';
import { Box, PlanCardChips } from '@common-fe/common-fe';

import { Plan } from '@/modules/plan/plan.types.ts';

import PlanCode from './PlanCode';
import PlanName from './PlanName';

interface Props {
  plan?: Plan;
  showPlansError?: boolean;
  isViewMode?: boolean;
  isEditMode?: boolean;
}

const PlanItem: React.FC<Props> = ({
  plan,
  showPlansError,
  isViewMode,
  isEditMode,
}) => {
  const hasChips = useMemo(() => {
    return (
      plan?.isRolloverChipsDisplay ||
      plan?.isGracePeriodChipsDisplay ||
      plan?.isRunOutChipsDisplay ||
      plan?.isAllowInvestmentsChipsDisplay
    );
  }, [plan]);
  
  return (
  <Box gap="xxxs" pad={{ vertical: 'm', horizontal: 'l' }} background="canvas" round="container1Round" border={{ size: 'small', color: 'border1' }} data-testid="plan-item">
    <PlanName
      defaultPlan={plan}
      showError={showPlansError}
      isViewMode={isViewMode}
      showEditAction={isEditMode}
    />
    {hasChips && (
      <PlanCardChips 
        isRolloverChipsDisplay={plan?.isRolloverChipsDisplay}
        isGracePeriodChipsDisplay={plan?.isGracePeriodChipsDisplay}
        isRunOutChipsDisplay={plan?.isRunOutChipsDisplay}
        isAllowInvestmentsChipsDisplay={plan?.isAllowInvestmentsChipsDisplay}
        maxRolloverAmount={plan?.maxRolloverAmount}
        maxRolloverAmountType={plan?.maxRolloverAmountType}
        rolloverClaimsType={plan?.rolloverClaimsType}
      />
    )}
    <PlanCode
      defaultPlan={plan}
      showError={showPlansError}
      isViewMode={isViewMode}
      showEditAction={isEditMode}
    />
  </Box>
  );
};

export default PlanItem;
